import { useEffect } from "react"
const useClickListener = (handlerFunction:any) => {
  useEffect(() => {
    if ( typeof window !== "undefined" && typeof document !== "undefined" ) {
      document.addEventListener("click", handlerFunction)
      return () => { document.removeEventListener("click", handlerFunction) }
    }
  }, [handlerFunction])
}
export default useClickListener
